<template>
  <div id="rateassist-location-details-tab-content">
    <div class="row">
      <div class="col-xs-12">
        <blockquote>
          Locations
        </blockquote>
      </div>
      <div v-show="showPreCarriage">
        <div class="col-xs-12 col-md-6">
          <div class="shadow">
            <div class="form-group">
              <label class="form-label" for="rate-assist-provider">Pre Carriage Locations</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Just start typing!"
                placeHolder="Select a Pre Carriage Location"
                :initVal="pc"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="location => addLocation('pc', 'preCarriage', 'PRE_CARRIAGE', location)"
                :autoFocus="true"
              />
            </div>
            <ul class="list-group">
              <li class="list-group-item" v-for="(l, i) in preCarriage">
                <div class="clearfix">
                  {{ displayLocation(l.location) }}
                  <span class="pull-right">
                    <div class="btn btn-danger" @click="remove('preCarriage', i)">
                      <i class="fa fa-times"></i>
                    </div>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-show="showOrigin">
        <div class="col-xs-12 col-md-6">
          <div class="shadow">
            <div class="form-group">
              <label class="form-label" for="rate-assist-provider">Origin Locations</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Just start typing!"
                placeHolder="Select an Origin Location"
                :initVal="o"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="location => addLocation('o', 'origin', 'ORIGIN', location)"
                :autoFocus="true"
              />
            </div>
            <ul class="list-group">
              <li class="list-group-item" v-for="(l, i) in origin">
                <div class="clearfix">
                  {{ displayLocation(l.location) }}
                  <span class="pull-right">
                    <div class="btn btn-danger" @click="remove('origin', i)">
                      <i class="fa fa-times"></i>
                    </div>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-show="showDestination">
        <div class="col-xs-12 col-md-6">
          <div class="shadow">
            <div class="form-group">
              <label class="form-label" for="rate-assist-provider">Destination Locations</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Just start typing!"
                placeHolder="Select an Destination Location"
                :initVal="d"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="location => addLocation('d', 'destination', 'DESTINATION', location)"
                :autoFocus="true"
              />
            </div>
            <ul class="list-group">
              <li class="list-group-item" v-for="(l, i) in destination">
                <div class="clearfix">
                  {{ displayLocation(l.location) }}
                  <span class="pull-right">
                    <div class="btn btn-danger" @click="remove('destination', i)">
                      <i class="fa fa-times"></i>
                    </div>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-show="showOnCarriage">
        <div class="col-xs-12 col-md-6">
          <div class="shadow">
            <div class="form-group">
              <label class="form-label" for="rate-assist-provider">On Carriage Locations</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Just start typing!"
                placeHolder="Select an On Carriage Location"
                :initVal="oc"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="location => addLocation('oc', 'onCarriage', 'ON_CARRIAGE', location)"
                :autoFocus="true"
              />
            </div>
            <ul class="list-group">
              <li class="list-group-item" v-for="(l, i) in onCarriage">
                <div class="clearfix">
                  {{ displayLocation(l.location) }}
                  <span class="pull-right">
                    <div class="btn btn-danger" @click="remove('onCarriage', i)">
                      <i class="fa fa-times"></i>
                    </div>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LookupHelperMixin from '../../admin/mixins/Helpers'
  import Autocomplete from '../../helpers/AutoComplete'
  import event from '../../../event'
  export default {
    name: 'LocationDetails',
    mixins: [ LookupHelperMixin ],
    components: {
      Autocomplete
    },
    props: ['showPreCarriage', 'showOrigin', 'showDestination', 'showOnCarriage', 'details'],
    data () {
      return {
        pc: null,
        o: null,
        d: null,
        oc: null,
        preCarriage: [],
        origin: [],
        destination: [],
        onCarriage: []
      }
    },
    watch: {
      details: {
        deep: true,
        handler: function (newVal, oldVal) {
          for (let prop in newVal) {
            if (this.hasOwnProperty(prop) && JSON.stringify(this[prop]) !== JSON.stringify(newVal[prop])) {
              this[prop] = newVal[prop]
            }
          }
        }
      }
    },
    methods: {
      addLocation (strProp, prop, category, location) {
        if (!this.contains(this[prop], location)) {
          if (location.id) {
            this[prop].push({
              location,
              category
            })
            this[strProp] = null
            this.locationSearchText = ''
            this.locationSearchResults = []
            this.$emit('updating', {
              preCarriage: this.preCarriage,
              origin: this.origin,
              destination: this.destination,
              onCarriage: this.onCarriage
            })
          }
        } else {
          event.$emit('toast', { type: 'warning', message: 'The list already contains this location' })
        }
      },
      contains (list, item) {
        return list.find(({location}) => location.id === item.id)
      },
      remove (prop, i) {
        this[prop].splice(i, 1)
        this.$emit('updating', {
          preCarriage: this.preCarriage,
          origin: this.origin,
          destination: this.destination,
          onCarriage: this.onCarriage
        })
      }
    }
  }
</script>
<style>
div.shadow {
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
  transition: all 0.5s;
  padding: 10px;
  margin-bottom: 10px;
}
div.shadow:hover {
  -webkit-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  -moz-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
}
</style>



// WEBPACK FOOTER //
// LocationDetails.vue?8c1335ec